import cn from 'classnames';
import {BigNumber} from 'ethers';
import {parseUnits} from 'ethers/lib/utils';
import React from 'react';
import {Control, Controller, UseFormRegisterReturn} from 'react-hook-form';
import {formatBigNumber} from '../../../lib/utilities';
import {TERC20Token} from '../../../redux/types';
import {TOKEN_LIST} from '../../constants';
import Select from '../select/select';
import './invest-amount.sass';

interface IProps extends UseFormRegisterReturn {
  label: string | JSX.Element;
  renderHint?: (rate: string, symbol?: string) => JSX.Element;
  className?: string;
  error?: string;
  // value?: string;
  onClickMax: VoidFunction;
  onClickMin: VoidFunction;
  investAmount: {
    maxInvest?: string;
    minInvest?: string;
    token?: Partial<TERC20Token>;
    rate: string;
    tgeToken?: string;
    tokenIcon?: string;
    value?: string;
  };
  tokens: Partial<TERC20Token>[];
  tokenSelect: {
    control: Control<any>;
    name: string;
    validation: Record<string, any>;
  };
}

const InvestAmount = React.forwardRef<HTMLInputElement, IProps>(
  (
    {
      error,
      // value,
      className,
      label,
      investAmount,
      tokenSelect,
      tokens,
      onClickMax,
      onClickMin,
      renderHint,
      ...inputProps
    },
    ref,
  ) => {
    return (
      <div className={cn('invest-amount', className)}>
        <div className="invest-amount__row">
          <div className="invest-amount__label">{label}</div>
          <div className="invest-amount__label">You will receive</div>
        </div>
        <div className="invest-amount__row">
          <div className="invest-amount__text-field">
            {/* {investAmount.token && (
              <img
                src={TOKEN_LIST[investAmount.token.symbol.toLowerCase()].icon}
                alt={`${investAmount.token.symbol} token`}
              />
            )} */}
            <Controller
              name={tokenSelect.name}
              control={tokenSelect.control}
              render={({field: {name, onChange, ref, value}}) => (
                <Select
                  onChange={onChange}
                  name={name}
                  value={value}
                  ref={ref}
                  options={tokens.map(el => ({
                    label: el.symbol || '',
                    value: el.address || '0x',
                    icon: el.symbol && TOKEN_LIST[el.symbol.toLowerCase()].icon,
                  }))}
                  disabled={inputProps.disabled}
                />
              )}
            />
            <input type="number" className="invest-amount__input" step="0.001" {...inputProps} ref={ref} />
          </div>
          <div className="invest-amount__receive">
            {investAmount.tokenIcon && <img src={investAmount.tokenIcon} alt="ggr" />}
            {+investAmount.rate &&
              formatBigNumber(
                parseUnits(investAmount.value ? investAmount.value : '1')
                  .mul(parseUnits('1'))
                  .div(parseUnits(investAmount.rate || '1')), // NOTE: division by zero
              )}
          </div>
        </div>
        <div className="invest-amount__row invest-amount__row-text">
          <div className={cn('invest-amount__desc', {_error: error})}>
            <span onClick={onClickMin}>
              Min {formatBigNumber(BigNumber.from(investAmount.minInvest))} {investAmount.token?.symbol}
            </span>{' '}
            <>— </>
            <span onClick={onClickMax}>
              Max {formatBigNumber(BigNumber.from(investAmount.maxInvest))} {investAmount.token?.symbol}
            </span>
          </div>
          {renderHint ? (
            renderHint(investAmount.rate, investAmount.tgeToken)
          ) : (
            <div className="invest-amount__desc">
              1 {investAmount.tgeToken} = {investAmount.rate} {investAmount.token?.symbol}
            </div>
          )}
        </div>
      </div>
    );
  },
);

export default InvestAmount;
